import React from 'react'
import { ResellerData } from '../../types';


interface TopResellersTableProps {
  data: ResellerData[];
  type?: string; // optional if you're not using it, or you can remove it
}

export const TopResellersTable: React.FC<TopResellersTableProps> = ({ data }) => (
  <div className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
    <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Top Resellers</h3>
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200 dark:border-gray-700">
            <th className="text-left py-3 text-sm font-medium text-gray-600 dark:text-gray-300">
              Name
            </th>
            <th className="text-right py-3 text-sm font-medium text-gray-600 dark:text-gray-300">
              Messages
            </th>
            <th className="text-right py-3 text-sm font-medium text-gray-600 dark:text-gray-300">
              Revenue
            </th>
          </tr>
        </thead>
        <tbody>
         {data.map((reseller, index) => (
            <tr
              key={index}
              className="border-b border-gray-100 dark:border-gray-800 last:border-b-0"
            >
              <td className="py-3 text-sm font-medium text-gray-900 dark:text-gray-100">
                {reseller.name}
              </td>
              <td className="py-3 text-sm text-gray-600 dark:text-gray-300 text-right">
                {reseller.messages}
              </td>
              <td className="py-3 text-sm font-semibold text-gray-900 dark:text-gray-100 text-right">
                {reseller.revenue}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);